import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {FulfillmentModel} from "../../models/fulfillment.model";

export class FulfillmentsTableComponent implements IController {

  displayAsItems: boolean;
  fulfillments: any;
  columns: any;
  dynamicColumns: any;
  packageDynamicColumns: any;
  isScrollable: boolean;
  isCollapse: boolean;
  isLoading: boolean;
  isInitialized: boolean;
  selectedFulfillmentId: string;
  selectedSteps: any[];
  selectedFulfillments: FulfillmentModel[];
  excludeMode: boolean;
  onOpen: Function;
  onDispatch: Function;
  onCancelOrder: Function;
  onEditOrder: Function;
  onAddOrderNote: Function;
  onDuplicateOrder: Function;
  onPrintBillOfLading: Function;
  onDownloadBillOfLading: Function;
  onSetOrderOnHold: Function;
  onSelectedFulfillmentChanged: Function;
  onFilterByType: Function;
  onCreateVoucher: Function;
  onRestoreFulfillment: Function;

  public fulfillmentsSelectedSteps: any = undefined;
  public readonly skeletonRows: undefined[] = Array.from({length: 10});

  constructor() {
  }

  $onInit() {
    this._mapSelectedStepsToFulfillments(this.fulfillments, this.selectedSteps);
  }

  $onChanges(changes) {
    if (changes.selectedSteps && !changes.selectedSteps.isFirstChange() ||
      changes.fulfillments && !changes.fulfillments.isFirstChange()) {
      this.$onInit();
    }
  };

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.rows-container')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  onToggleSelectAll() {
    this.onSelectedFulfillmentChanged({
      selectedSteps: [],
      selectedFulfillments: [],
      excludeMode: !this.excludeMode
    });
  }

  onToggleSelectFulfillment(fulfillment) {
    const selectedStepsIds = _.map(this.selectedSteps, selectedStep => {
      return selectedStep.id;
    })
    const isFulfillmentSelected = !!_.filter(fulfillment.fulfillmentSteps, step => {
      return _.includes(selectedStepsIds, step.id)
    }).length;

    const selectedStepsCopy = angular.copy(this.selectedSteps);
    const selectedFulfillmentsCopy = angular.copy(this.selectedFulfillments);

    if (isFulfillmentSelected) {
      _.forEach(fulfillment.fulfillmentSteps, step => {
        if (_.includes(selectedStepsIds, step.id)) {
          const selectedStepIndex = _.findIndex(selectedStepsCopy, selectedStep => {
            return step.id === selectedStep.id;
          })
          selectedStepsCopy.splice(selectedStepIndex, 1);
        }
      })

      const fulfillmentIndex = this.selectedFulfillments.findIndex(f => f.id === fulfillment.id);
      selectedFulfillmentsCopy.splice(fulfillmentIndex, 1);
    } else {
      _.forEach(fulfillment.fulfillmentSteps, step => {
        if (step.matchFilter) {
          selectedStepsCopy.push(step);
        }
      })

      selectedFulfillmentsCopy.push(fulfillment);
    }

    this.onSelectedFulfillmentChanged({
      selectedSteps: selectedStepsCopy,
      selectedFulfillments: selectedFulfillmentsCopy,
      excludeMode: this.excludeMode
    });

  }

  private _mapSelectedStepsToFulfillments(fulfillments, selectedSteps) {
    this.fulfillmentsSelectedSteps = {}
    _.forEach(fulfillments, f => {
      const fulfillmentStepsIds = _.map(f.fulfillmentSteps, 'id');
      this.fulfillmentsSelectedSteps[f.id] = _.chain(selectedSteps)
        .filter((s) => {
          return _.includes(fulfillmentStepsIds, s.id)
        })
        .map('id')
        .value();
    })
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentsTable', {
    bindings: {
      displayAsItems: '<?',
      fulfillments: '<',
      columns: '<',
      dynamicColumns: '<',
      packageDynamicColumns: '<?',
      isScrollable: '<',
      isCollapse: '<',
      selectedFulfillmentId: '<',
      isLoading: '<',
      isInitialized: '<?',
      selectedSteps: '<',
      selectedFulfillments: '<',
      excludeMode: '<',
      onSelectedFulfillmentChanged: '&',
      onOpen: '&',
      onDispatch: '&',
      onCancelOrder: '&',
      onEditOrder: '&',
      onAddOrderNote: '&',
      onDuplicateOrder: '&',
      onPrintBillOfLading: '&',
      onDownloadBillOfLading: '&',
      onSetOrderOnHold: '&',
      onFilterByType: '&',
      onCreateVoucher: '&',
      onRestoreFulfillment: '&'
    },
    template: require('./fulfillments-table.html').default,
    controller: FulfillmentsTableComponent
  });
